<template>
    <BModal id="des-modal" v-bind:no-close-on-backdrop=true dialogClass="modal-dialog-left modal-lg" bodyClass="p-3" v-model="showDesSel" size="xl">
        <template #header>
            <h2>
                Вибір опису
            </h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="showDesSel = !showDesSel">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        
        <BTable :items="items" primary-key="id" :fields="fields" stacked="md" show-empty small>
            
            <template  v-slot:cell(title)="data">
                <BTooltip>
                    <template #target>
                        <span class="cursor-pointer" @click="titleClicked(data.item)">
                            {{data.item.title}}
                        </span>
                    </template>
                    Перегляд
                </BTooltip>
            </template>
            
            <template  v-slot:cell(action)="data">
                <BTooltip>
                    <template #target>
                        <span class="cursor-pointer" @click="selectDescription(data.item)">
                            <div class='icon-stack  text-center fs-xxl'>
                                <i class="base base-1 icon-stack-3x opacity-100 color-info-600"></i>
                                <i class="far fa-file icon-stack-1x opacity-100 color-white"></i>
                            </div>
                        </span>
                    </template>
                    Вибрати
                </BTooltip>
            </template>
            
            <template  v-slot:cell(delete)="data">
                <BTooltip>
                    <template #target>
                        <span class="cursor-pointer"
                              data-html="true"
                              title="Видалити"
                              @click="deleteDescription(data.item)"
                        >
                            <div class='icon-stack  text-center fs-xxl '>
                                <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                                <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                            </div>
                        </span>
                    </template>
                    Видалити
                </BTooltip>
            </template>
        </BTable>
        
        <div class="pb-5">
            <BFormInput type="text" placeholder="Назва шаблону" v-model="title"></BFormInput>
        </div>
       
        
        <QuillEditor
            v-model:content="text"
            contentType="html"
            theme="snow"
            :toolbar="editor_rules"
            placeholder="Введіть опис…"
            class="tender-editor"
        />
        
        <template #footer>
            <BButton size="xl" variant="outline-success" @click="addnew"  class="btn btn-lg  waves-effect waves-themed mr-3">
                <i class="fal fa-plus mr-1"></i>
                Створити новий шаблон
            </BButton>
            
            <BButton size="xl" variant="outline-warning" @click="showDesSel = !showDesSel"  class="btn btn-lg  waves-effect waves-themed mr-3">
                <i class="fal fa-times mr-1"></i>
                Закрити
            </BButton>
        </template>
    </BModal>

</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BTable,
    BTooltip,
} from 'bootstrap-vue-next';

export default {
    
    name: "description_templates",
    components : {
        BFormInput,
        BButton,
        BModal,
        BTable,
        QuillEditor,
        BTooltip
    },
    data() {
        return {
            title : '',
            text : '',
            is_load : false,
            showDesSel: false,
            items: [],
            fields: [
                { key: 'title', label: 'Шаблон', sortable: true },
                { key: 'action', label: 'Заповнити'  },
                { key: 'delete', label: 'Видалити'  },
            ],
            editor_rules: [
                ['bold', 'italic', 'underline', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['clean'] // по желанию (ластик)
            ]
        }
    },
    
    emits : ['setTemplate'],
    
    created() {
        EventBus.$on('show_description',this.show)
    },
    
    methods:{
        
        show() {
            this.load_descriptions();
            this.showDesSel = true;
        },
        
        addnew() {
            this.add_descriptions()
        },
        
        titleClicked(item) {
            this.title = item.title;
            this.text = item.text;
        },
        
        selectDescription(item) {
            console.log(item);
            
            EventBus.$emit('show_toast', {err: 'Заповнено з шаблону '+ item.title, type: "success", title: 'Заповнено опис'});
            this.$emit('setTemplate',item.text);
            
            this.close();
        },
        
        close() {
            this.showDesSel = false;
            this.text = '';
            this.title = '';
        },
        
        async load_descriptions()  {
            this.items = [];
            this.is_load = true;
            
            await api.get('/tenders/sales/tenders/helpers/description/templates').then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        async add_descriptions()  {
            await api.put('/tenders/sales/tenders/helpers/description/templates',{
                "title": this.title,
                "text": this.text
            }).then(({data}) => {
                this.load_descriptions();
            }).catch(e => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        async deleteDescription(item)  {
            await api.delete('/tenders/sales/tenders/helpers/description/templates/' + item.id).then(({data}) => {
                this.load_descriptions();
            }).catch(e => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        selectUserSel(){
            EventBus.$emit('users_selected',{users:this.items.filter(item => {return item.selected}).map(item => {return item.id})});
        },
    }
    
}
</script>